import axios from 'axios';

// Using global axios.defaults.baseURL set in index.jsx

class LegalNoticesService {
    static async getNotices(location, audience = 'all') {
        try {
            const response = await axios.get(
                `/front/legal-notices/notices/${location}?audience=${audience}`
            );

            // SAFETY CHECKS
            if (!response || !response.data) {
                console.warn('Invalid response structure from legal notices API');
                return { status: true, data: [] };
            }

            // Ensure data is an array
            if (response.data.status && response.data.data) {
                const data = Array.isArray(response.data.data) ? response.data.data : [];
                return { status: true, data: data };
            }

            return { status: true, data: [] };

        } catch (error) {
            console.error('Error fetching legal notices:', error);

            // If it's a network error or 404, return empty data gracefully
            if (error.response && error.response.status === 404) {
                console.warn('Legal notices endpoint not found - returning empty data');
                return { status: true, data: [] };
            }

            // For any other error, return empty data structure
            return { status: true, data: [] };
        }
    }

    static async getComplianceNotices(jurisdiction, type) {
        try {
            const response = await axios.get(
                `/front/legal-notices/compliance/${jurisdiction}/${type}`
            );

            if (response && response.data && response.data.status) {
                const data = Array.isArray(response.data.data) ? response.data.data : [];
                return { status: true, data: data };
            }

            return { status: true, data: [] };
        } catch (error) {
            console.error('Error fetching compliance notices:', error);
            return { status: true, data: [] };
        }
    }

    static async trackView(noticeId) {
        if (!noticeId) return;

        try {
            await axios.post(`/front/legal-notices/${noticeId}/view`);
        } catch (error) {
            console.error('Error tracking view:', error);
            // Don't throw error - tracking is not critical
        }
    }

    static async trackClick(noticeId) {
        if (!noticeId) return;

        try {
            await axios.post(`/front/legal-notices/${noticeId}/click`);
        } catch (error) {
            console.error('Error tracking click:', error);
            // Don't throw error - tracking is not critical
        }
    }

    static async trackDismissal(noticeId) {
        if (!noticeId) return;

        try {
            await axios.post(`/front/legal-notices/${noticeId}/dismiss`);
        } catch (error) {
            console.error('Error tracking dismissal:', error);
            // Don't throw error - tracking is not critical
        }
    }

    static async recordAcknowledgment(noticeId, userId) {
        if (!noticeId) return;

        try {
            await axios.post(`/front/legal-notices/${noticeId}/acknowledge`, {
                userId
            });
        } catch (error) {
            console.error('Error recording acknowledgment:', error);
            // Don't throw error - tracking is not critical
        }
    }
}

export default LegalNoticesService;
